import { findElementById, findFirstChild, findNextSibling, insertAfter, insertAsChild, moveAfter, moveAsChild, moveToTemplate } from "./TemplateJsonSlice";
import templateJsonStore from "./TemplateJsonStore";
import templateSelectedRootStore from "./TemplateSelectedRootStore";
import { resetRoot, selectRoot } from "./TemplateSelectedRootSlice";

import toolBoxItemStore from "./ToolBoxItemStore";
import { searchByTagName } from "./ToolBoxItemSlice";
import templateSelectedItemStore from "./TemplateSelectedItemStore";
import { selectItem } from "./TemplateSelectedItemSlice";
import alertStore from "./AlertStore";
import { setAlert } from "./AlertSlice";

export class TemplateDragController {
    constructor(host) {
        this.host = host;
        host.addController(this);

        /**テンプレートルートのselectか、TopTemplateListのどちらかの上にマウスポインタがいる場合true*/
        this.isRootOverSelect = false;
        this.MOVE_THRESHOLD = 10;
        this.touchTimer = null;
        this.touchStartX = null;
        this.touchStartY = null;
        // this.isScroll = false;
        this.touchCurrentX = null;
        this.touchCurrentY = null;
        this.scrollInterval = null;
        this.topScrollInterval = null;
        // テンプレートルートの上にポインターがあるときのタイマー
        this.isRootOnTimer = null;

        /** MOVEの際にdragFuncメソッドを呼び出すかのフラグ trueで呼び出す*/
        this.isDragFunc = false;

        this._lastPreviewTargetId = null;
        this._lastPreviewAddMethod = null;
        this._lastPreviewDragType = null;

        // リスナー解除用にバインド済みの参照を保持
        this._boundGlobalMove = this.handleGlobalMove.bind(this);
        this._boundTouchStart = this.handleTouchStart.bind(this);
        this._boundTouchEnd = this.handleTouchEnd.bind(this);
    }

    hostConnected() {
        window.addEventListener('mousemove', this._boundGlobalMove, { passive: false });
        window.addEventListener('mousedown', this._boundTouchStart, { passive: false });
        window.addEventListener('mouseup', this._boundTouchEnd);

        window.addEventListener('touchstart', this._boundTouchStart, { passive: false });
        window.addEventListener('touchend', this._boundTouchEnd);
        // toolboxの移動検知も統合
        window.addEventListener('touchmove', this.handleGlobalMove.bind(this), { passive: false });
    }

    hostDisconnected() {
        window.removeEventListener('mousemove', this._boundGlobalMove);
        window.removeEventListener('mousedown', this._boundTouchStart);
        window.removeEventListener('mouseup', this._boundTouchEnd);

        window.removeEventListener('touchstart', this._boundTouchStart);
        window.removeEventListener('touchend', this._boundTouchEnd);
    }

    hostUpdated() {
        const nodes = this.host.shadowRoot.querySelectorAll('.node');
        nodes.forEach(node => {
            if (node.dataset.nodeType !== 'app') {
                //node.setAttribute('draggable', 'true');
            }
            if (node !== null && !node.hasAttribute('data-event-drag-attached')) {

                //node.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
                node.addEventListener('touchmove', this.handleGlobalMove.bind(this), { passive: false });

                //windowに登録したtouchendと同じだが、これがないとtopTemplateListで選択後になぜかtouchendイベントが発生しない
                // event.stopPropagation();を呼び出しているので2回は実行されないので気持ち悪いが動作には問題ない
                node.addEventListener('touchend', this.handleTouchEnd.bind(this));
            }
            node.setAttribute('data-event-drag-attached', '');
        });

        const trashNodes = this.host.shadowRoot.querySelectorAll('.template-trash-box');
        trashNodes.forEach(node => {
            if (node !== null && !node.hasAttribute('data-event-drag-attached')) {

                //node.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
                node.addEventListener('touchmove', this.handleGlobalMove.bind(this), { passive: false });

                //windowに登録したtouchendと同じだが、これがないとtopTemplateListで選択後になぜかtouchendイベントが発生しない
                // event.stopPropagation();を呼び出しているので2回は実行されないので気持ち悪いが動作には問題ない
                node.addEventListener('touchend', this.handleTouchEnd.bind(this));
            }
            node.setAttribute('data-event-drag-attached', '');
        });
    }

    handleTrashItemMove(event) {

        const clientPoint = this.getClientPoint(event);

        if (this.host.isDragging) {
            event.preventDefault();

            //ポインタの下のエレメントを探す
            let dropTarget
            if (window.TouchEvent && event instanceof TouchEvent) {
                dropTarget = this.host.shadowRoot.elementFromPoint(clientPoint.x, clientPoint.y);

            } else {
                dropTarget = this.host.shadowRoot.elementFromPoint(clientPoint.x, clientPoint.y);
            }

            if (dropTarget === null) {
                return;
            }


            // ドラッグ中のパネル表示
            const dx = Math.abs(this.touchStartX - clientPoint.x);
            const dy = Math.abs(this.touchStartY - clientPoint.y);

            // 移動距離が閾値を超えた場合にのみドラッグ処理
            if (dx > this.MOVE_THRESHOLD || dy > this.MOVE_THRESHOLD) {
                //customDragImageをタッチポイントに移動
                const customDragImage = document.querySelector('.custom-drag-image');
                if (customDragImage != null) {

                    const rect = customDragImage.getBoundingClientRect();
                    const x = clientPoint.x - rect.width / 2;
                    const y = clientPoint.y - rect.height / 2;
                    customDragImage.style.top = y + 'px';

                    if (event instanceof MouseEvent) {
                        customDragImage.style.left = x + 'px';
                    } else if (window.TouchEvent && event instanceof TouchEvent) {
                        customDragImage.style.left = x - 80 + 'px';
                    }

                    // 現在のタッチY座標を取得
                    this.touchCurrentX = clientPoint.x;
                    this.touchCurrentY = clientPoint.y;

                }

            }
        }

    }

    findSiblingAbove(element, y) {
        var children = element.children;

        for (var i = children.length - 1; i >= 0; i--) {
            var rect = children[i].getBoundingClientRect();

            if (rect.bottom < y && children[i] !== element) {
                if (children[i].classList.contains('node')) {
                    return children[i];
                }
            }
        }
        return null;
    }

    getElementFromPointDeep(x, y) {
        let el = document.elementFromPoint(x, y);
        while (el && el.shadowRoot) {
            let inner = el.shadowRoot.elementFromPoint(x, y);
            if (!inner || inner === el) break;
            el = inner;
        }
        return el;
    }

    // プレビューを消去する共通関数を強化（無条件で消去イベントをディスパッチ）
    _clearPreviewEvent() {
        this._lastPreviewTargetId = null;
        this._lastPreviewAddMethod = null;
        this._lastPreviewDragType = null;
        window.dispatchEvent(new CustomEvent('clear-renderzone-preview'));
    }

    handleDragOver(event) {
        if (!this.host.showTemplatePopup) {
            event.preventDefault()

            // 選択済みのポイントを一旦すべてクリア
            const addPoints = this.host.shadowRoot.querySelectorAll('.node-add-point');
            addPoints.forEach((addPoint) => {
                addPoint.classList.remove('node-add-point-selected');
            });

            // ドラッグ対象が app の場合、レイアウト内への挿入プレビューを無効化します
            let dragNode = null;
            if (window.dragItemType === "node-id" && window.dragItemId) {
                dragNode = findElementById(templateJsonStore.getState().templateJson, window.dragItemId);
            }
            if (dragNode && (dragNode.type === 'app' || dragNode.tagName === 'app')) {
                this._clearPreviewEvent();
                return;
            }

            // dragItemTypeが空（ドラッグ中ではない）ならプレビューを消して終了
            if (window.TouchEvent && event instanceof TouchEvent) {
                // タッチイベント時のバリデーション
            } else {
                if (!window.dragItemType || window.dragItemType === '') {
                    this._clearPreviewEvent();
                    return;
                }
            }

            // マウスまたはタッチの座標を取得
            const clientPoint = this.getClientPoint(event);

            // 現在ポインタの下にある要素を特定
            var targetElement = this.host.shadowRoot.elementFromPoint(clientPoint.x, clientPoint.y);
            if (targetElement === null) {
                this._clearPreviewEvent();
                return;
            }

            // 要素がノードのパーツだった場合、親の .node 自体をターゲットとして特定
            targetElement = targetElement.classList.contains('node') ? targetElement : targetElement.closest(".node");

            if (targetElement === null) {
                this._clearPreviewEvent();
                return
            }

            // 特定の入力系タグは子要素を持てないため、プレビューを消してドロップ不可とする
            switch (targetElement.dataset.nodeType) {
                case 'ons-input':
                case 'ons-checkbox':
                case 'ons-radio':
                case 'ons-search-input':
                case 'ons-switch':
                    this._clearPreviewEvent();
                    return;
            }

            // 自分自身や自分の子孫にドロップしようとしていないかチェック（移動モード時）
            let dragNodeId = null;
            if (window.dragItemType === "node-id") {
                dragNodeId = window.dragItemId;
                if (targetElement.dataset.nodeId === dragNodeId) {
                    this._clearPreviewEvent();
                    return;
                }
                let parentNode = targetElement.parentNode;
                while (parentNode && parentNode.id !== 'dom-tree') {
                    if (parentNode.dataset && parentNode.dataset.nodeId === dragNodeId) {
                        this._clearPreviewEvent();
                        return;
                    }
                    parentNode = parentNode.parentNode;
                }
            }

            // ターゲット要素内のどの位置（前後の兄弟か、最初の子か）に挿入するかを計算
            var previousSibling = targetElement ? this.findSiblingAbove(targetElement, clientPoint.y + 2) : null;

            if (previousSibling && previousSibling.classList.contains("node")) {
                // 既存ノードの間に挿入する場合
                let nextSibling = previousSibling.nextElementSibling;
                let nextNode = nextSibling ? nextSibling.nextElementSibling : null;

                // 移動対象そのものの位置なら表示しない
                if (nextNode && nextNode.dataset && nextNode.dataset.nodeId === dragNodeId) {
                    this._clearPreviewEvent();
                    return;
                }
                if (previousSibling.dataset && previousSibling.dataset.nodeId === dragNodeId) {
                    this._clearPreviewEvent();
                    return;
                }

                // 挿入ポイントを可視化
                if (nextSibling && nextSibling.classList.contains("node-add-point")) {
                    nextSibling.classList.add("node-add-point-selected");
                }
            } else {
                // 親要素の先頭に挿入する場合
                if (targetElement) {
                    let firstChild = targetElement.querySelector('.node')
                    if (firstChild && firstChild.dataset && firstChild.dataset.nodeId === dragNodeId) {
                        this._clearPreviewEvent();
                        return;
                    }
                    let point = targetElement.querySelector('.node-add-point');
                    if (point) {
                        point.classList.add('node-add-point-selected');
                    }
                }
            }

            // --- プレビュー表示（RenderZoneControllerへの通知）ロジック ---
            const activePoint = this.host.shadowRoot.querySelector('.node-add-point-selected');
            if (activePoint) {
                let previewTargetNode = activePoint.previousElementSibling;
                let addMethod = 'after'; // 基本は兄弟として後ろに追加
                let targetId = '';

                if (previewTargetNode && previewTargetNode.classList.contains('node')) {
                    // ターゲットノードの「後ろ」に挿入
                    targetId = previewTargetNode.dataset.nodeId;
                    addMethod = 'after';
                } else {
                    // 前にノードがない場合は、その場所の親要素を特定して「最初の子」として挿入
                    previewTargetNode = activePoint.closest('.node');
                    if (previewTargetNode) {
                        targetId = previewTargetNode.dataset.nodeId;
                        addMethod = 'child';
                    }
                }

                // 前回のプレビュー送信時からターゲットや方法が変わった場合のみイベントを発火
                if (targetId && (targetId !== this._lastPreviewTargetId || addMethod !== this._lastPreviewAddMethod || window.dragItemType !== this._lastPreviewDragType)) {
                    this._lastPreviewTargetId = targetId;
                    this._lastPreviewAddMethod = addMethod;
                    this._lastPreviewDragType = window.dragItemType;

                    window.dispatchEvent(new CustomEvent('update-renderzone-preview', {
                        detail: {
                            targetId: targetId,
                            method: addMethod,
                            dragItemType: window.dragItemType,
                            dragItemId: window.dragItemId
                        },
                        bubbles: true,
                        composed: true
                    }));
                }
            } else {
                // 挿入ポイントが見つからなければプレビューを消去
                this._clearPreviewEvent();
            }
        }
    }

    handleToolboxItemMove(event) {
        //タッチの場合はツールボックスからドラッグしたときにtop-template-listが開かないのでこちらで開く
        this.isRootOverSelect = false;

        if (this.host.isDragging) {
            const clientPoint = this.getClientPoint(event);

            //ポイントの下の要素を取得し、その先祖にthisがなければ処理を中止
            let thisNode
            if (this.host) {
                thisNode = this.host;
            } else {
                thisNode = this;
            }

            const pointElement = thisNode.shadowRoot.elementFromPoint(clientPoint.x, clientPoint.y);
            // if (!pointElement) return;
            // const rootNode = pointElement.getRootNode().host
            // if (!rootNode || rootNode.localName !== thisNode.localName) {
            //     //イベントコンテナ内でなければ処理をしない
            //     return;
            // }

            // const dropTarget = this.host.shadowRoot.elementFromPoint(clientPoint.x, clientPoint.y);
            const dropTarget = pointElement;

            if (dropTarget === null) {
                return;
            }

            //dropTargetの祖先にselectクラスがあるかを探す
            let selectParent = dropTarget.closest('.select');
            if (selectParent) {
                this.isRootOverSelect = true;
            }

            //dropTargetの祖先にtop-template-listクラスがあるかを探す
            let topTemplateListParent = dropTarget.closest('.top-template-list');
            if (topTemplateListParent) {
                this.isRootOverSelect = true;
            }

            //top-template-listの開閉処理
            //this.isRootOverSelectがfalseの場合は0.5秒経ってからtop-template-listを閉じる
            //0.5秒以内に戻ってきたら閉じる処理をキャンセル
            if (!this.isRootOverSelect) {
                if (this.host.showTemplatePopup) {
                    if (!this.touchTimer) {
                        this.touchTimer = setTimeout(() => {
                            this.host.closeTemplateListPopup();
                            this.touchTimer = null;
                            //top-template-list内で移動する先をクリア
                            this.templateRootOverElement = null;
                        }, 500);
                    }
                }
            } else {
                //開いていない場合開く
                if (!this.host.showTemplatePopup) {
                    this.host.openTemplateListPopup(event);
                }
                if (this.touchTimer) {
                    clearTimeout(this.touchTimer);
                    this.touchTimer = null;
                }
            }

        }
    }

    // スクロール条件をチェックして実行する関数をメソッド化
    _checkAndScroll() {
        if (!this.host.showTemplatePopup) {
            const panel = this.host.shadowRoot.querySelector('#dom-tree');
            if (!panel) return;
            const panelRect = panel.getBoundingClientRect();

            // 現在の座標がパネルの範囲内にいない場合は処理を停止
            if (this.touchCurrentY < panelRect.top ||
                this.touchCurrentY > panelRect.bottom ||
                this.touchCurrentX < panelRect.left ||
                this.touchCurrentX > panelRect.right) {
                return;
            }

            if (this.touchCurrentY < panelRect.top + 30 && this.touchCurrentY > panelRect.top) {
                const scrollDistance = 30 - Math.abs(this.touchCurrentY - panelRect.top);
                panel.scrollTo({
                    top: panel.scrollTop - scrollDistance,
                    behavior: "smooth",
                });
            } else if (this.touchCurrentY > panelRect.bottom - 30 && this.touchCurrentY < panelRect.bottom) {
                const scrollDistance = 30 - Math.abs(this.touchCurrentY - panelRect.bottom);
                panel.scrollTo({
                    top: panel.scrollTop + scrollDistance,
                    behavior: "smooth",
                });
            } else {
                clearInterval(this.scrollInterval);
                this.scrollInterval = null;
            }
        } else {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        }
    }

    // top-template-listのスクロール条件をチェックして実行する関数をメソッド化
    _topTemplateListCheckAndScroll() {
        if (this.host.showTemplatePopup) {
            const topTemplateList = this.host.shadowRoot.querySelector('.top-template-list');
            if (!topTemplateList) return;
            const topTemplateListRect = topTemplateList.getBoundingClientRect();

            if (this.touchCurrentY < topTemplateListRect.top ||
                this.touchCurrentY > topTemplateListRect.bottom ||
                this.touchCurrentX < topTemplateListRect.left ||
                this.touchCurrentX > topTemplateListRect.right) {
                return;
            }

            if (this.touchCurrentY < topTemplateListRect.top + 30 && this.touchCurrentY > topTemplateListRect.top) {
                const scrollDistance = 30 - Math.abs(this.touchCurrentY - topTemplateListRect.top);
                topTemplateList.scrollTo({
                    top: topTemplateList.scrollTop - scrollDistance,
                    behavior: "smooth",
                });
            } else if (this.touchCurrentY > topTemplateListRect.bottom - 30 && this.touchCurrentY < topTemplateListRect.bottom) {
                const scrollDistance = 30 - Math.abs(this.touchCurrentY - topTemplateListRect.bottom);
                topTemplateList.scrollTo({
                    top: topTemplateList.scrollTop + scrollDistance,
                    behavior: "smooth",
                });
            } else {
                clearInterval(this.topScrollInterval);
                this.topScrollInterval = null;
            }
        } else {
            clearInterval(this.topScrollInterval);
            this.topScrollInterval = null;
        }
    }

    handleGlobalMove(event) {
        const clientPoint = this.getClientPoint(event);

        if (this.isDragFunc) {
            this.dragFunc(event);
            this.isDragFunc = false;
        }

        if (window.dragItemType && window.dragItemType !== '') {
            this.host.isDragging = true;
        }

        if (this.host.isDragging) {
            // ブラウザのデフォルトスクロールは止めるが、伝播の停止(stopImmediatePropagation)は行わない
            if (event.cancelable) {
                event.preventDefault();
            }

            this.touchCurrentX = clientPoint.x;
            this.touchCurrentY = clientPoint.y;

            this.isRootOverSelect = false;
            this.isTrashOver = false;

            this.handleDragOver(event);

            // スクリプトエディタ上のホバー判定
            const dropTargetDeep = this.getElementFromPointDeep(clientPoint.x, clientPoint.y);
            if (dropTargetDeep && window.dragItemType === "node-id" && window.dragItemId) {
                let node = dropTargetDeep;
                let isScriptEditorDrop = false;
                while (node) {
                    if (node.tagName && node.tagName.toLowerCase() === 'script-container') {
                        if (node.style.display !== 'none') {
                            isScriptEditorDrop = true;
                        }
                        break;
                    }
                    node = node.parentNode || node.host;
                }

                if (isScriptEditorDrop) {
                    window.dispatchEvent(new CustomEvent('drag-over-script-editor', {
                        detail: {
                            clientX: clientPoint.x,
                            clientY: clientPoint.y
                        }
                    }));
                }
            }

            let dragItemId;
            let dragItem;
            let dragItemTopObj = null;
            if (window.dragItemType === "node-id") {
                dragItemId = window.dragItemId;
                dragItem = findElementById(templateJsonStore.getState().templateJson, dragItemId);
            } else {
                dragItemTopObj = toolBoxItemStore.getState().toolboxItems.items.find((i) => i.componentName === window.dragItemType);
                if (!dragItemTopObj) {
                    dragItemTopObj = toolBoxItemStore.getState().toolboxItems.customItems.find((i) => i.componentName === window.dragItemType);
                }
            }

            let dropTarget = this.host.shadowRoot.elementFromPoint(clientPoint.x, clientPoint.y);
            if (dropTarget === null) return;

            let selectParent = dropTarget.closest('.select');
            if (selectParent) this.isRootOverSelect = true;

            let topTemplateListParent = dropTarget.closest('.top-template-list');
            if (topTemplateListParent) this.isRootOverSelect = true;

            const trashOver = dropTarget.closest('.template-trash-box');
            if (trashOver) this.isTrashOver = true;

            if (!this.isRootOverSelect) {
                if (this.host.showTemplatePopup && !this.touchTimer) {
                    this.touchTimer = setTimeout(() => {
                        this.host.closeTemplateListPopup();
                        this.touchTimer = null;
                        this.templateRootOverElement = null;
                    }, 500);
                }
            } else {
                if (!this.host.showTemplatePopup) this.host.openTemplateListPopup(event);
                if (this.touchTimer) {
                    clearTimeout(this.touchTimer);
                    this.touchTimer = null;
                }
            }

            if (!this.isTrashOver) {
                if (!this.trashTouchTimer) {
                    this.trashTouchTimer = setTimeout(() => {
                        this.host.handleCloseTrashBox();
                        this.trashTouchTimer = null;
                    }, 500);
                }
            } else {
                if (this.trashTouchTimer) {
                    clearTimeout(this.trashTouchTimer);
                    this.trashTouchTimer = null;
                }
            }

            if (Math.abs(this.touchStartX - clientPoint.x) > this.MOVE_THRESHOLD ||
                Math.abs(this.touchStartY - clientPoint.y) > this.MOVE_THRESHOLD) {
                if (this.isRootOnTimer) {
                    clearTimeout(this.isRootOnTimer);
                    this.isRootOnTimer = null;
                }
            }

            const topTemplateItem = dropTarget.closest('.top-template-item');
            if (topTemplateItem) {
                const targetTemplateId = topTemplateItem.dataset.templateId;
                clearTimeout(this.isRootOnTimer);
                this.isRootOnTimer = setTimeout(() => {
                    templateSelectedRootStore.dispatch(selectRoot(targetTemplateId));
                }, 500);
            }

            const topTemplateList = dropTarget.closest('.top-template-item');
            Array.from(this.host.shadowRoot.querySelectorAll(".move-point")).forEach(movePoint => {
                movePoint.style.visibility = 'hidden';
            });

            if (topTemplateList) {
                if (dragItem || dragItemTopObj) {
                    if (
                        (dragItem && (['ons-page', 'ons-action-sheet', 'ons-dialog', 'ons-toast', 'ons-popover'].includes(dragItem.tagName))) ||
                        (dragItemTopObj && (['ons-page', 'ons-action-sheet', 'ons-dialog', 'ons-toast', 'ons-popover'].includes(dragItemTopObj.componentName))) ||
                        (dragItemTopObj && dragItemTopObj.component && (['ons-page', 'ons-action-sheet', 'ons-dialog', 'ons-toast', 'ons-popover'].includes(dragItemTopObj.component.tagName)))
                    ) {
                        const topTemplateListTop = topTemplateList.getBoundingClientRect().top;
                        let currentElem = dropTarget;
                        let currentElemY = clientPoint.y;
                        let foundTopItem = null;
                        let foundTarget = false;
                        while (currentElemY >= topTemplateListTop) {
                            foundTopItem = currentElem.closest('.top-template-item');
                            if (foundTopItem) {
                                foundTarget = true;
                                break;
                            }
                            currentElemY -= 1;
                            currentElem = this.host.shadowRoot.elementFromPoint(clientPoint.x, currentElemY);
                            if (!currentElem) break;
                        }

                        if (foundTarget) {
                            const topTemplateItemCenter = foundTopItem.getBoundingClientRect().top + (foundTopItem.getBoundingClientRect().bottom - foundTopItem.getBoundingClientRect().top) / 2;
                            let movePoint = null;
                            if (clientPoint.y < topTemplateItemCenter && clientPoint.y >= foundTopItem.getBoundingClientRect().top) {
                                if (foundTopItem.dataset.templateType === 'app') {
                                    movePoint = foundTopItem.nextElementSibling;
                                    if (movePoint) movePoint.style.visibility = 'visible';
                                } else {
                                    movePoint = foundTopItem.previousElementSibling;
                                    if (movePoint) movePoint.style.visibility = 'visible';
                                }
                            } else if (clientPoint.y > topTemplateItemCenter && clientPoint.y < foundTopItem.getBoundingClientRect().bottom) {
                                movePoint = foundTopItem.nextElementSibling;
                                if (movePoint) movePoint.style.visibility = 'visible';
                            }
                            if (movePoint) {
                                if (this.templateRootDragElement !== movePoint.previousElementSibling) {
                                    this.templateRootOverElement = movePoint.previousElementSibling;
                                }
                            }
                        }
                    }
                }
            }

            const dx = Math.abs(this.touchStartX - clientPoint.x);
            const dy = Math.abs(this.touchStartY - clientPoint.y);

            if (dx > this.MOVE_THRESHOLD || dy > this.MOVE_THRESHOLD) {
                const customDragImage = document.querySelector('.custom-drag-image');
                if (customDragImage) {
                    const rect = customDragImage.getBoundingClientRect();
                    const x = clientPoint.x - rect.width / 2;
                    const y = clientPoint.y - rect.height / 2;
                    customDragImage.style.top = y + 'px';
                    customDragImage.style.left = (event instanceof MouseEvent ? x : x - 80) + 'px';

                    const panel = this.host.shadowRoot.querySelector('#dom-tree');
                    if (panel) {
                        const panelRect = panel.getBoundingClientRect();
                        if (clientPoint.y < panelRect.top + 30 || clientPoint.y > panelRect.bottom - 30) {
                            if (!this.scrollInterval) this.scrollInterval = setInterval(() => this._checkAndScroll(), 100);
                        }
                    }
                    if (!this.topScrollInterval) this.topScrollInterval = setInterval(() => this._topTemplateListCheckAndScroll(), 100);
                }
            }
        } else {
            if (Math.abs(this.touchStartX - clientPoint.x) > this.MOVE_THRESHOLD ||
                Math.abs(this.touchStartY - clientPoint.y) > this.MOVE_THRESHOLD) {
                clearTimeout(this.touchTimer);
                this.touchTimer = null;
            }
        }
    }

    getClientPoint(event) {
        if (!event) {
            return { x: 0, y: 0 };
        }
        if (event instanceof CustomEvent && event.detail) {
            return this.getClientPoint(event.detail);
        }
        if (event.detail && (event.detail.touches || event.detail.changedTouches || event.detail.clientX !== undefined)) {
            return this.getClientPoint(event.detail);
        }
        if (event.touches && event.touches.length > 0) {
            return {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY
            };
        }
        if (event.changedTouches && event.changedTouches.length > 0) {
            return {
                x: event.changedTouches[0].clientX,
                y: event.changedTouches[0].clientY
            };
        }
        if (event.clientX !== undefined && event.clientY !== undefined) {
            return {
                x: event.clientX,
                y: event.clientY
            };
        }
        return { x: 0, y: 0 };
    }

    dragFunc(event) {
        // MOVE_THRESHOLDの範囲内であればドラッグを開始
        if (!this.host.isDragging) {
            //タッチしているポイントの要素を取得
            const touchTarget = this.host.shadowRoot.elementFromPoint(this.touchStartX, this.touchStartY);

            let nodeParent = null;
            if (touchTarget.closest(".template-trash-box-node")) {
                // ゴミ箱の場合
                nodeParent = touchTarget.closest(".template-trash-box-node")
            } else {
                // レイアウト上の場合
                nodeParent = touchTarget.closest('.node');
            }

            if (nodeParent) {
                this.templateRootDragElement = nodeParent;
                //eventにnodeを設定
                event.customData = nodeParent;
                this.handleDragStart(event);
                if ('vibrate' in navigator) {
                    navigator.vibrate(50);
                }

                // ドラッグ開始が確定した時点で、これ以上のイベント（スクロール等）をキャンセルする
                this.host.isDragging = true;
                if (event.cancelable) event.preventDefault();
            }
        }
    }

    handleTouchStart(event) {
        //長押しして0.3秒経ったら振動させる
        const clientPoint = this.getClientPoint(event);
        this.touchStartX = clientPoint.x;
        this.touchStartY = clientPoint.y;

        //ポイントの下がnode要素の配下か？
        const touchTarget = this.host.shadowRoot.elementFromPoint(this.touchStartX, this.touchStartY);
        if (touchTarget) {
            let nodeParent = null;
            if (touchTarget.closest(".template-trash-box-node")) {
                nodeParent = touchTarget.closest('.template-trash-box-node');
                this.movingSource = "trashBox";
            } else {
                // レイアウト上の場合
                nodeParent = touchTarget.closest('.node');
                this.movingSource = "layout";
            }

            if (nodeParent) {
                if (event instanceof MouseEvent) {
                    //マウスの場合はMoveイベントで1回だけdragFuncを呼び出す
                    //初回だけ呼び出しのためにフラグにtrueをいれる
                    this.isDragFunc = true;
                } else if (window.TouchEvent && event instanceof TouchEvent) {
                    this.touchTimer = setTimeout(function () {
                        this.dragFunc(event);
                    }.bind(this), 300);
                }

                if (this.host.isDragging) {
                    event.preventDefault();
                } else {
                    // 他の要素がタッチを奪い取らないように伝播は止めるが、スクロールはMOVEの閾値まで許容する
                    event.stopPropagation()
                }
            }

        }
    }

    handleDragStart(event) {
        //20240120
        event.stopPropagation();
        this.host.isDragging = true;
        let dataValue
        let nodeType
        if (window.TouchEvent && event instanceof TouchEvent) {
            dataValue = event.customData.dataset.nodeId;
            nodeType = event.customData.dataset.nodeType;
        } else {
            // dataValue = event.currentTarget.dataset.nodeId;
            // nodeType = event.currentTarget.dataset.nodeType;
            dataValue = event.customData.dataset.nodeId;
            nodeType = event.customData.dataset.nodeType;
        }

        //event.dataTransfer.setData("item-type", "node-id");
        //event.dataTransfer.setData("node-id", dataValue);
        window.dragItemType = "node-id";
        window.dragItemId = dataValue;

        // 全体にドラッグ開始を通知
        window.dispatchEvent(new CustomEvent('app-drag-start'));


        // ドラッグ中二表示する半透明な要素を作成
        const dragTarget = findElementById(templateJsonStore.getState().templateJson, dataValue);
        const customDragImage = document.createElement('div');
        customDragImage.className = 'custom-drag-image';
        customDragImage.style.position = 'fixed'; // 絶対位置指定
        customDragImage.style.top = '-99999px';  // 画面外へ
        customDragImage.style.left = '-99999px';
        customDragImage.style.height = '20px';
        customDragImage.style.zIndex = '99999'; // 最上位に表示
        customDragImage.style.pointerEvents = 'none';
        //ユーザーが選択できないようにする
        customDragImage.style.userSelect = 'none';
        //白背景で透明
        customDragImage.style.background = 'rgba(255, 255, 255, 0.5)';
        customDragImage.style.minWidth = '20px';
        customDragImage.style.padding = '10px';
        customDragImage.style.borderRadius = '5px';
        //マウスイベントを無効にする
        customDragImage.style.pointerEvents = 'none';

        let explain
        if (dragTarget.explain && dragTarget.explain !== '') {
            explain = dragTarget.explain
        } else if (dragTarget.domId && dragTarget.domId !== '') {
            explain = dragTarget.domId;
        } else {
            explain = dragTarget.tagName;
        }
        customDragImage.innerHTML = explain;
        document.body.appendChild(customDragImage);

        const clientPoint = this.getClientPoint(event);

        // ドラッグイメージをカスタム要素に設定
        //　カーソルの位置を要素の中心に設定
        if (window.TouchEvent && event instanceof TouchEvent) {
            //タッチ位置にcustomDragImageを設定
            //const touch = event.touches[0];
            const rect = customDragImage.getBoundingClientRect();
            const x = clientPoint.x - rect.width / 2;
            const y = clientPoint.y - rect.height / 2;
            customDragImage.style.top = y + 'px';
            customDragImage.style.left = x - 80 + 'px';
        } else if (event instanceof MouseEvent) {
            //event.dataTransfer.setDragImage(customDragImage, customDragImage.clientWidth / 2, customDragImage.clientHeight / 2);
            //タッチ位置にcustomDragImageを設定
            const rect = customDragImage.getBoundingClientRect();
            const x = clientPoint.x - rect.width / 2;
            const y = clientPoint.y - rect.height / 2;
            customDragImage.style.top = y + 'px';
            customDragImage.style.left = x + 'px';
        } else {
            throw new Error('Invalid event type');
        }
    }

    async handleTouchEnd(event) {
        this._clearPreviewEvent();
        if (this.host.isDragging) {
            this.host.isDragging = false;

            //custom-drag-imageクラスの要素を探す
            const customDragImage = document.querySelector('.custom-drag-image');
            if (customDragImage != null) {
                customDragImage.remove();
            }

            const clientPoint = this.getClientPoint(event);

            // D&DによるUIアクションの挿入判定
            const dropTargetDeep = this.getElementFromPointDeep(clientPoint.x, clientPoint.y);
            if (dropTargetDeep && window.dragItemType === "node-id" && window.dragItemId) {
                const appContainer = document.querySelector('app-container');
                const scriptContainer = appContainer?.shadowRoot?.querySelector('script-container');
                if (scriptContainer && scriptContainer.style.display !== 'none') {
                    // ドロップ先が scriptContainer 内部かどうか
                    let node = dropTargetDeep;
                    let isScriptEditorDrop = false;
                    while (node) {
                        if (node === scriptContainer) {
                            isScriptEditorDrop = true;
                            break;
                        }
                        node = node.parentNode || node.host;
                    }

                    if (isScriptEditorDrop) {
                        window.dispatchEvent(new CustomEvent('drop-to-script-editor', {
                            detail: {
                                nodeId: window.dragItemId,
                                clientX: clientPoint.x,
                                clientY: clientPoint.y
                            }
                        }));

                        this.movingSource = null;
                        this.templateRootOverElement = null;
                        this.templateRootDragElement = null;
                        window.dragItemType = "";
                        window.dragItemId = "";

                        Array.from(this.host.shadowRoot.querySelectorAll(".move-point")).forEach(movePoint => {
                            movePoint.style.visibility = 'hidden';
                        });
                        clearInterval(this.scrollInterval);
                        this.scrollInterval = null;
                        clearInterval(this.topScrollInterval);
                        this.topScrollInterval = null;
                        this.isDragFunc = false;

                        // 全体にドラッグ終了を通知
                        window.dispatchEvent(new CustomEvent('app-drag-end'));

                        return;
                    }
                }
            }

            // ドラッグ対象が app であり、エディタへのドロップでなかった場合は処理をキャンセルしてクリーンアップします
            let dragNode = null;
            if (window.dragItemType === "node-id" && window.dragItemId) {
                dragNode = findElementById(templateJsonStore.getState().templateJson, window.dragItemId);
            }
            if (dragNode && (dragNode.type === 'app' || dragNode.tagName === 'app')) {
                this.movingSource = null;
                this.templateRootOverElement = null;
                this.templateRootDragElement = null;
                this.host.isDragging = false;

                clearTimeout(this.touchTimer);
                clearInterval(this.scrollInterval);
                this.touchTimer = null;
                this.scrollInterval = null;
                clearInterval(this.topScrollInterval);
                this.topScrollInterval = null;
                this.isDragFunc = false;
                window.dragItemType = "";
                window.dragItemId = "";
                event.stopPropagation();

                // 全体にドラッグ終了を通知
                window.dispatchEvent(new CustomEvent('app-drag-end'));
                return;
            }

            //ポイントの配下の祖先にnodeクラスがあるか
            let targetElement = this.host.shadowRoot.elementFromPoint(clientPoint.x, clientPoint.y);
            if (targetElement && targetElement.localName === "tool-box" && window.dragItemId !== '') {
                //ツールボックスアイテムにドロップした場合
                // begin-tool-box-item-from-template イベントを発行
                this.host.dispatchEvent(new CustomEvent('begin-tool-box-item-from-template', {
                    detail: {
                        templateItemId: window.dragItemId,
                    },
                    bubbles: true,
                    composed: true
                }));
            } else {
                if (targetElement) {
                    if (targetElement.classList.contains('node') || targetElement.closest('.node')) {
                        // テンプレートにドロップした場合 (nodeクラス配下のエレメント)
                        targetElement = targetElement.classList.contains('node') ? targetElement : targetElement.closest(".node");
                        await this.handleDrop(event);
                    } else if (targetElement.classList.contains('fab-trash-box') || targetElement.closest('.fab-trash-box')) {
                        // ゴミ箱にドロップした場合 (fab-trash-boxクラス配下のエレメント)
                        this.templateRootOverElement = targetElement.classList.contains('fab-trash-box') ? targetElement : targetElement.closest(".fab-trash-box");
                    }
                }

                if (targetElement === null) {
                    // 選択済みのポイントを削除
                    const addPoints = this.host.shadowRoot.querySelectorAll('.node-add-point');
                    addPoints.forEach((addPoint) => {
                        addPoint.classList.remove('node-add-point-selected');
                    });
                }
            }
        }

        //top-template-listの処理
        //すべてのmove-pointを非表示状態にする
        Array.from(this.host.shadowRoot.querySelectorAll(".move-point")).forEach(movePoint => {
            movePoint.style.visibility = 'hidden';
        });

        // ツールボックスアイテムからトップテンプレートにドラッグしたときのためのもの
        let dataValue = window.dragItemType;
        toolBoxItemStore.dispatch(searchByTagName(dataValue));
        let searchItem = toolBoxItemStore.getState().toolboxItems.searchResult;
        if (!searchItem) {
            searchItem = {};
            searchItem.tagName = dataValue;
            searchItem.attributes = {};
            searchItem.text = "";
            searchItem.children = [];
            searchItem.explain = "";
        }

        // ゴミ箱に移動の場合
        if (this.templateRootOverElement && this.templateRootOverElement.classList.contains('fab-trash-box') && this.templateRootDragElement) {
            // clear-iconクラスのエレメントを取得
            const clearIcon = this.templateRootDragElement.querySelector('.clear-icon');
            if (clearIcon) {
                this.templateRootDragElement.dataset.deleteReserve = true;
                clearIcon.click();
            }
        } else if (this.templateRootOverElement && this.templateRootDragElement) {
            //テンプレート上に移動先がある場合は移動させる
            //ゴミ箱からの場合はいちどtemplate側に戻す
            if (this.movingSource === 'trashBox') {
                templateJsonStore.dispatch(moveToTemplate({ targetId: this.templateRootDragElement.dataset.nodeId }));
            }
            templateJsonStore.dispatch(moveAfter({ destId: this.templateRootOverElement.dataset.templateId, srcId: this.templateRootDragElement.dataset.nodeId }));

        } else if (this.templateRootOverElement && searchItem) {
            const payload = {
                'targetId': this.templateRootOverElement.dataset.templateId,
                'newElement':
                {
                    'tagName': searchItem.tagName,
                    'attributes': searchItem.attributes,
                    'text': searchItem.text,
                    'children': searchItem.children,
                    'domId': searchItem.domId,
                    'explain': searchItem.explain,
                }
            }

            templateJsonStore.dispatch(insertAfter(payload));
            // ツールボックスからテンプレートにドロップすると、TemplateContainerのhandleClickOutsideが呼ばれるため、トップテンプレートリストが閉じてしまう
            // グローバル変数に閉じないための情報を入れて回避する
            window.isToolboxItemDrop = true;
        }

        this.movingSource = null;
        this.templateRootOverElement = null;
        this.templateRootDragElement = null;
        this.host.isDragging = false;

        //長押しタイマーをキャンセル
        clearTimeout(this.touchTimer);
        //スクロールイベントをキャンセル
        clearInterval(this.scrollInterval);
        this.touchTimer = null;
        this.scrollInterval = null;
        clearInterval(this.topScrollInterval);
        this.topScrollInterval = null;
        // this.isScroll = false;
        this.isDragFunc = false;
        window.dragItemType = "";
        window.dragItemId = "";
        this.host.isDragging = false;
        event.stopPropagation();

        // 全体にドラッグ終了を通知
        window.dispatchEvent(new CustomEvent('app-drag-end'));
    }

    async handleDrop(event) {
        //イベントがキャンセル可能であれば
        if (event.cancelable) {
            event.preventDefault();
        }
        let dataValue = window.dragItemType;

        let tagName;
        let tagDisable = false;
        if (dataValue === 'HTML Tag') {
            // ダイアログを待つ非同期処理に入る前に、ドラッグ状態を完全にクリアします。
            // これを行わないと、ダイアログ表示中のマウス移動等によりドラッグイベントが再発火し、
            // プレビューの破線が消えずに残る不具合が発生します。
            window.dragItemType = "";
            window.dragItemId = "";
            this.host.isDragging = false;
            this._clearPreviewEvent();
            window.dispatchEvent(new CustomEvent('app-drag-end'));

            const appContainer = document.querySelector('app-container');
            tagName = await appContainer.showHtmlTagSelectDialog();
            if (tagName) {
                const regex = /^[a-zA-Z0-9\-_]+$/;
                if (regex.test(tagName)) {
                    dataValue = tagName;
                } else {
                    alertStore.dispatch(setAlert('タグとして不適切な文字列です'));
                    tagDisable = true;
                }

            } else {
                tagDisable = true;
            }

            if (tagDisable) {
                // 選択済みのポイントを削除
                const addPoints = this.host.shadowRoot.querySelectorAll('.node-add-point');
                addPoints.forEach((addPoint) => {
                    addPoint.classList.remove('node-add-point-selected');
                });
                return;
            }
        }

        const addPoint = this.host.shadowRoot.querySelector('.node-add-point-selected');

        if (!addPoint) return;

        let targetNode = addPoint.previousElementSibling;
        let addMethod;
        let payload;

        if (dataValue === 'node-id') {
            //const nodeId = event.dataTransfer.getData('node-id');
            const nodeId = window.dragItemId;
            if (targetNode.classList.contains('node')) {
                // ひとつ上の兄弟がnodeであれば、その要素を追加先のターゲットにする
                addMethod = moveAfter;
            } else {
                // 親要素を追加先のターゲットにする 
                targetNode = addPoint.closest('.node');
                addMethod = moveAsChild;
            }

            payload = {
                'destId': targetNode.dataset.nodeId,
                'srcId': nodeId
            }
        } else {
            if (targetNode.classList.contains('node')) {
                // ひとつ上の兄弟がnodeであれば、その要素を追加先のターゲットにする
                addMethod = insertAfter;
            } else {
                // 親要素を追加先のターゲットにする 
                targetNode = addPoint.closest('.node');
                addMethod = insertAsChild;
            }

            toolBoxItemStore.dispatch(searchByTagName(dataValue));
            let searchItem = toolBoxItemStore.getState().toolboxItems.searchResult;
            if (!searchItem) {
                searchItem = {};
                searchItem.tagName = tagName;
                searchItem.attributes = {};
                searchItem.text = "";
                searchItem.children = [];
                searchItem.explain = "";
            }

            payload = {
                'targetId': targetNode.dataset.nodeId,
                'newElement':
                {
                    'tagName': searchItem.tagName,
                    'attributes': searchItem.attributes,
                    'text': searchItem.text,
                    'children': searchItem.children,
                    'domId': searchItem.domId,
                    'explain': searchItem.explain,
                }
            }
        }

        //ゴミ箱からの場合はいちどtemplate側に戻す
        if (this.movingSource === 'trashBox') {
            templateJsonStore.dispatch(moveToTemplate({ targetId: window.dragItemId }));
        }

        templateJsonStore.dispatch(
            addMethod(
                payload
            )
        );


        let nextSelectElement;
        if (addMethod.type === 'templateJson/moveAfter' || addMethod.type === 'templateJson/insertAfter') {
            // addMethodがmoveAfterかinsertAfterであればpayload.targetIdの兄弟要素の次の要素をselectedItemに指定する
            nextSelectElement = findNextSibling(templateJsonStore.getState(), targetNode.dataset.nodeId);

        } else if (addMethod.type === 'templateJson/moveAsChild' || addMethod.type === 'templateJson/insertAsChild') {
            // addMethodがmoveAsChildかinsertAsChildであればpayload.targetIdの最初の子要素をselectedItemに指定する
            nextSelectElement = findFirstChild(templateJsonStore.getState(), targetNode.dataset.nodeId);
        }
        templateSelectedItemStore.dispatch(selectItem(nextSelectElement.id));

        this.host.handleWindowResize(event);
    }

}